exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".danger-border[data-v-7c41ecf6] {\n  border-left: 5px solid red;\n}\n", ""]);

